import { PaidFeatures } from '~app/pages/Pricing/experiments/grow_2792_pnp_refresh_v1/types';
import { DetailsPackageData } from '~app/pages/Pricing/transformers/details/types';
import { Packages } from '~shared/constants/pricing';
import { FeatureSet } from '~shared/types/pricing/features';
import { DiscountInfo, PackageList, PricingPackage } from '~shared/types/pricing/pricingsvc';

export enum PackageType {
  Individual = 'individual',
  Teams = 'teams',
  Educational = 'educational',
  Enterprise = 'enterprise',
  Details = 'details', // `pricing/details` is a valid route that renders the teams details page
}

type Currency = {
  code: string;
};

export type PackageSkuCost = {
  skuType: string;
  cost: number;
  currency: Currency;
};

export type PackageSkuCosts = PackageSkuCost[];

export enum PACKAGE_PRICE_TYPE {
  SUMMARY = 'Summary',
  DETAIL = 'Detail',
  COMPARISON = 'Comparison',
}

export type PACKAGE_PRICE_TYPE_KEYS = keyof typeof PACKAGE_PRICE_TYPE;
export type PACKAGE_PRICE_TYPE_VALUES = `${PACKAGE_PRICE_TYPE}`;
export type DisplayString = React.ReactElement | string | undefined;
export type PackageData = PricingPackage;
export type PackageDataSet = PackageData[];
export type PackageSet = Packages[];

export type PackagesStateType = {
  allPackages: PricingPackage[];
  userPackage: PricingPackage;
  displayPackages: PricingPackage[];
  displayPackageSet: PackageList;
  detailsPackageData: DetailsPackageData;
  packagesToDisplayState: PackageList;
  discountInfo: DiscountInfo | undefined;
  paidFeatures: PaidFeatures[] | undefined; // GROW-2792 PnP refresh - IPPM Embed Modal
  showEduDiscount: boolean;
  comparePlans: boolean;
  overageCost: PackageSkuCost | undefined;
  getPackageById(packageId: number | string): PricingPackage;
};

export type PackageMap = Record<number, PricingPackage>;

export type PackagesProviderProps = {
  packagesToDisplay: PackageList;
  showEduDiscount: boolean;
  comparePlans: boolean;
  canonicalPath: string;
  subPath?: string;
  children: React.ReactNode;
  isIPPM?: boolean;
};

export type PackageProps = {
  packageName: Packages;
  skuCost: PackageSkuCosts;
  comparisonSkuCost: PackageSkuCosts;
  ribbonText?: string | boolean | null;
  features: FeatureSet;
  comparePlans: boolean;
  isLastPackage: boolean;
  discountInfo?: DiscountInfo;
  paidFeatures?: PaidFeatures[]; // GROW-2792 PnP refresh - IPPM Embed Modal
};

export type RoutePackageMap = {
  [x: string]: PackageSet;
};
